(function() {
  'use strict';

  var StickyAddToCart = (function() {
    var els = {};
    var state = {
      isInitialized: false,
      isLoading: false,
      currentVariantId: null,
      variants: {},
      moneyFormat: '${{amount}}',
      productTitle: '',
      defaultImage: '',
      pendingAddRequestId: 0
    };

    var strings = {
      addToCart: 'Add to cart',
      soldOut: 'Sold out'
    };

    var successTimer = null;
    var boundHandlers = {};

    function init() {
      if (state.isInitialized) {
        destroy();
      }

      els.bar = document.querySelector('[data-sticky-add-to-cart]');
      if (!els.bar) return;

      els.productJson = els.bar.querySelector('[data-sticky-product-json]');
      els.price = els.bar.querySelector('[data-sticky-price]');
      els.comparePrice = els.bar.querySelector('[data-sticky-compare-price]');
      els.btn = els.bar.querySelector('[data-sticky-add-btn]');
      els.btnText = els.bar.querySelector('[data-sticky-btn-text]');
      els.btnLoader = els.bar.querySelector('[data-sticky-btn-loader]');
      els.btnCheck = els.bar.querySelector('[data-sticky-btn-check]');
      els.image = els.bar.querySelector('[data-sticky-image]');
      els.title = els.bar.querySelector('[data-sticky-title]');

      if (!els.productJson) return;

      if (window.theme && window.theme.strings) {
        if (window.theme.strings.addToCart) strings.addToCart = window.theme.strings.addToCart;
        if (window.theme.strings.soldOut) strings.soldOut = window.theme.strings.soldOut;
      }

      parseProductData();
      preloadImages();
      bindEvents();
      showBar();

      state.isInitialized = true;
    }

    function preloadImages() {
      var keys = Object.keys(state.variants);
      for (var i = 0; i < keys.length; i++) {
        var v = state.variants[keys[i]];
        if (v.featured_image) {
          var img = new Image();
          img.src = v.featured_image;
        }
      }
      if (state.defaultImage) {
        var def = new Image();
        def.src = state.defaultImage;
      }
    }

    function showBar() {
      if (!els.bar) return;
      els.bar.classList.add('is-visible');
      els.bar.setAttribute('aria-hidden', 'false');
    }

    function parseProductData() {
      try {
        var data = JSON.parse(els.productJson.textContent);
        var variantsArray = data.variants || [];

        state.variants = {};
        for (var i = 0; i < variantsArray.length; i++) {
          var v = variantsArray[i];
          state.variants[Number(v.id)] = {
            id: Number(v.id),
            available: Boolean(v.available),
            price: Number(v.price) || 0,
            compare_at_price: v.compare_at_price ? Number(v.compare_at_price) : null,
            title: v.title || '',
            featured_image: v.featured_image || null
          };
        }

        state.currentVariantId = Number(data.currentVariantId) || null;
        state.moneyFormat = data.moneyFormat || '${{amount}}';
        state.productTitle = data.productTitle || '';
        state.defaultImage = data.defaultImage || '';
      } catch (e) {
        console.warn('[StickyAddToCart] Failed to parse product data', e);
      }
    }

    function bindEvents() {
      boundHandlers.addToCart = handleAddToCart;
      boundHandlers.variantChange = onVariantChange;
      boundHandlers.keydown = onKeydown;

      if (els.btn) {
        els.btn.addEventListener('click', boundHandlers.addToCart);
        els.btn.addEventListener('keydown', boundHandlers.keydown);
      }

      document.addEventListener('variant:change', boundHandlers.variantChange);
    }

    function onVariantChange(e) {
      if (!e || !e.detail || !e.detail.variant) return;
      var variantId = Number(e.detail.variant.id);
      if (variantId && variantId !== state.currentVariantId) {
        state.currentVariantId = variantId;
        updateUI();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleAddToCart();
      }
    }

    function getCurrentVariant() {
      if (state.currentVariantId === null) return null;
      return state.variants[state.currentVariantId] || null;
    }

    function updateUI() {
      var variant = getCurrentVariant();
      if (!variant) {
        updateButtonFallback();
        return;
      }

      updatePrice(variant);
      updateButton(variant);
      updateVariantInfo(variant);
    }

    function updateVariantInfo(variant) {
      if (!variant) return;

      if (els.image) {
        var newImg = variant.featured_image || state.defaultImage;
        if (newImg) {
          els.image.src = newImg;
          els.image.srcset = newImg + ' 1x, ' + newImg.replace('120x', '240x') + ' 2x';
        }
      }

      if (els.title) {
        var displayTitle = state.productTitle;
        if (variant.title && variant.title !== 'Default Title') {
          displayTitle += ' - ' + variant.title;
        }
        els.title.textContent = displayTitle;
      }
    }

    function updateButtonFallback() {
      if (!els.btn || !els.btnText) return;
      els.btnText.textContent = strings.addToCart;
      els.btn.disabled = false;
      els.btn.setAttribute('aria-label', strings.addToCart);
      els.bar.classList.remove('is-sold-out');
    }

    function updatePrice(variant) {
      if (!els.price) return;
      els.price.textContent = formatMoney(variant.price);

      if (els.comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          els.comparePrice.textContent = formatMoney(variant.compare_at_price);
          els.comparePrice.classList.remove('hide');
        } else {
          els.comparePrice.classList.add('hide');
        }
      }
    }

    function updateButton(variant) {
      if (!els.btn || !els.btnText) return;

      if (variant.available) {
        els.btnText.textContent = strings.addToCart;
        els.btn.disabled = false;
        els.btn.setAttribute('aria-label', strings.addToCart);
        els.bar.classList.remove('is-sold-out');
      } else {
        els.btnText.textContent = strings.soldOut;
        els.btn.disabled = true;
        els.btn.setAttribute('aria-label', strings.soldOut);
        els.bar.classList.add('is-sold-out');
      }

      resetButton();
    }

    function handleAddToCart() {
      if (state.isLoading) return;

      var variant = getCurrentVariant();
      if (!variant || !variant.available) return;

      state.isLoading = true;
      state.pendingAddRequestId++;
      var currentRequestId = state.pendingAddRequestId;

      showLoadingState();

      var formData = new FormData();
      formData.append('id', String(variant.id));
      formData.append('quantity', String(getQuantity()));

      var cartUrl = getCartAddUrl();

      fetch(cartUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(response) {
          if (currentRequestId !== state.pendingAddRequestId) return null;
          return response.text().then(function(text) {
            var data = text ? JSON.parse(text) : null;
            if (!response.ok) {
              throw data || new Error('Add to cart failed');
            }
            return data;
          });
        })
        .then(function(data) {
          if (!data) return;
          state.isLoading = false;
          showSuccessState();
          dispatchCartEvents(data);
        })
        .catch(function(error) {
          if (currentRequestId !== state.pendingAddRequestId) return;
          state.isLoading = false;
          resetButton();
          handleAddError(error);
        });
    }

    function getCartAddUrl() {
      if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
        return window.theme.routes.cartAdd;
      }

      var baseUrl = '/cart/add.js';

      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        var root = window.Shopify.routes.root;
        if (root && root !== '/') {
          return root.replace(/\/$/, '') + baseUrl;
        }
      }

      var localeMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(\/|$)/i);
      if (localeMatch) {
        return '/' + localeMatch[1] + baseUrl;
      }

      return baseUrl;
    }

    function dispatchCartEvents(data) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: {
          product: data,
          addToCartBtn: els.btn,
          quantity: getQuantity()
        }
      }));

      if (typeof jQuery !== 'undefined' && jQuery.fn) {
        try {
          jQuery(document).trigger('ajaxProduct:added', [{
            product: data
          }]);
        } catch (e) {}
      }
    }

    function handleAddError(error) {
      try {
        var msg = error && (error.description || error.message) ? (error.description || error.message) : 'Add to cart failed';
        console.warn('[StickyAddToCart] Add failed:', msg);
      } catch (e) {}
    }

    function getQuantity() {
      var qtyInput = document.querySelector('[data-pm-qty]') || document.querySelector('.js-qty__num[name="quantity"]');
      if (qtyInput) {
        var val = parseInt(qtyInput.value, 10);
        if (!isNaN(val) && val > 0) return val;
      }
      return 1;
    }

    function showLoadingState() {
      if (!els.btn) return;
      els.btn.classList.add('is-loading');
      els.btn.classList.remove('is-added');
      els.btn.setAttribute('aria-busy', 'true');
      if (els.btnText) els.btnText.classList.add('hide');
      if (els.btnCheck) els.btnCheck.classList.add('hide');
      if (els.btnLoader) els.btnLoader.classList.remove('hide');
    }

    function showSuccessState() {
      if (!els.btn) return;
      els.btn.classList.remove('is-loading');
      els.btn.classList.add('is-added');
      els.btn.setAttribute('aria-busy', 'false');
      if (els.btnLoader) els.btnLoader.classList.add('hide');
      if (els.btnText) els.btnText.classList.add('hide');
      if (els.btnCheck) els.btnCheck.classList.remove('hide');

      if (successTimer) clearTimeout(successTimer);
      successTimer = setTimeout(function() {
        resetButton();
        successTimer = null;
      }, 1500);
    }

    function resetButton() {
      if (!els.btn) return;
      els.btn.classList.remove('is-loading', 'is-added');
      els.btn.setAttribute('aria-busy', 'false');
      if (els.btnText) els.btnText.classList.remove('hide');
      if (els.btnLoader) els.btnLoader.classList.add('hide');
      if (els.btnCheck) els.btnCheck.classList.add('hide');
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';

      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        try {
          return window.theme.Currency.formatMoney(cents, state.moneyFormat);
        } catch (e) {}
      }

      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(cents, state.moneyFormat);
        } catch (e) {}
      }

      var format = state.moneyFormat;
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.floor(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');

      format = format.replace('{{amount}}', amount);
      format = format.replace('{{amount_no_decimals}}', amountNoDecimals);
      format = format.replace('{{amount_with_comma_separator}}', amountWithComma);

      return format;
    }

    function destroy() {
      if (successTimer) {
        clearTimeout(successTimer);
        successTimer = null;
      }

      if (els.btn && boundHandlers.addToCart) {
        els.btn.removeEventListener('click', boundHandlers.addToCart);
        els.btn.removeEventListener('keydown', boundHandlers.keydown);
      }

      if (boundHandlers.variantChange) {
        document.removeEventListener('variant:change', boundHandlers.variantChange);
      }

      els = {};
      state.isInitialized = false;
      state.isLoading = false;
      state.pendingAddRequestId++;
    }

    return {
      init: init,
      destroy: destroy,
      updateVariant: function(variantId) {
        state.currentVariantId = Number(variantId);
        updateUI();
      }
    };
  })();

  function initStickyBar() {
    StickyAddToCart.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e && e.target && e.target.querySelector('[data-sticky-add-to-cart]')) {
      setTimeout(initStickyBar, 100);
    }
  });

  document.addEventListener('shopify:section:unload', function() {
    StickyAddToCart.destroy();
  });

  window.StickyAddToCart = StickyAddToCart;
})();
